import React, { useEffect, useState } from 'react';
// Embedded data URI — renders instantly, even offline.
import { WASSLA_W_LOGO as wLogo } from '../assets/wasslaLogoData';
import './AnimatedSplash.css';

/**
 * AnimatedSplash — iter353 static brand splash.
 *
 * Shows the official green-and-orange Wassla "W" centered on a clean
 * white screen. Per operator spec: no glow, no shadow, no halo, no
 * sweep and no logo animation. Only the container fades out at the
 * end so the hand-off to the app shell stays smooth.
 *
 * The `variant` prop is kept for API compatibility with App.js but no
 * longer changes the visuals.
 */
const HOLD_MS = 900;
const EXIT_MS = 350;

export default function AnimatedSplash({ variant = 'luxury', onFinish }) {
  const [phase, setPhase] = useState('hold'); // hold -> exit -> done

  useEffect(() => {
    const t1 = setTimeout(() => setPhase('exit'), HOLD_MS);
    const t2 = setTimeout(() => { if (onFinish) onFinish(); }, HOLD_MS + EXIT_MS);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, [onFinish]);

  return (
    <div
      className={`splash splash--${phase}`}
      style={{ '--exit-dur': `${EXIT_MS}ms` }}
      data-testid="app-splash"
    >
      <img
        src={wLogo}
        alt="Wassla"
        className="splash__logo"
        draggable={false}
      />
    </div>
  );
}
